import { useState } from "react";
import "./_Products.scss";
import _ProductsSideNav from "./_ProductSideNav/_ProductSideNav";
import _ProductPanel from "./_ProductContent/_ProductPanel/_ProductPanel";
import _AnimeSeriesPanel from "./_ProductContent/_AnimeSeriesPanel/_AnimeSeriesPanel";
import _CategoryPanel from "./_ProductContent/_CategoryPanel/_CategoryPanel";
import _ManufacturerPanel from "./_ProductContent/_ManufacturerPanel/_ManufacturerPanel";
function _Products({ side = 0 }) {
  //console.log({_ProductsSideNav,_ProductPanel,_AnimeSeriesPanel,_CategoryPanel, _ManufacturerPanel,});
  const sidenavstructure = [
    "PRODUCTS",
    "CATEGORY",
    "MANUFACTURER",
    "ANIME SERIES",
  ];
  const content = [
    _ProductPanel,
    _CategoryPanel,
    _ManufacturerPanel,
    _AnimeSeriesPanel,
  ];
  const [activeSideNav, setActiveSideNav] = useState(side); // Usually start from 0

  const ActiveComponent = content[activeSideNav]; // get the component
  return (
    <>
      <section className="admin-product-container">
        <_ProductsSideNav
          sidenavstructure={sidenavstructure}
          activeSideNav={activeSideNav}
          setActiveSideNav={setActiveSideNav}
        />
        <ActiveComponent />
      </section>
    </>
  );
}

export default _Products;
